export default __webpack_public_path__ + "static/media/lock.24b5fc1d.svg";